import React, { useState, useEffect, useCallback, useMemo } from 'react';
import { getData, updateData, getcountries, getpaymentType } from '../../../services/admin/ParticipantForm/pendingOnsiteParticipantFormServices';
import { Modal, Button, Table } from 'react-bootstrap';
import DataTable from 'react-data-table-component';
import Header from '../../../components/Layout/Header';
import Footer from '../../../components/Layout/Footer';
import Sidebar from '../../../components/Layout/Sidebar';
import Spinner from '../../../components/Spinner';
import Swal from 'sweetalert2';

const PendingOnsiteParticipantForm = () => {
  const [dataList, setDataList] = useState([]);
  const [form, setForm] = useState({
    id: '',
    billing_address: '',
    billing_countries: '',
    billing_email: '',
    billing_full_name: '',
    billing_phone_no: '',
    createdAt: '',
    currency_type: '',
    no_of_ticket: '',
    occupancy_type: '',
    payment_id: '',
    payment_type: '',
    participant_type: '',
    onsite_status: '',
    refund_status: '',
    reg_amount: '',
    reg_amount_usd: '',
    reg_category: '',
    reg_type: '',
    series: '',
    note: '',
    notes: [],
    sub_domain: '',
    subject: '',
    updatedAt: '',
  });
  const [modalType, setModalType] = useState('');
  const [showModal, setShowModal] = useState(false);
  const [searchText, setSearchText] = useState('');
  const [currentPage, setCurrentPage] = useState(1);
  const [loading, setLoading] = useState(true);
  const [dropdownData, setDropdownData] = useState({
    countries: [],
    paymentType: [],
  });

  // Fetch data list
  const fetchData = useCallback(async () => {
    try {
      const data = await getData({ onsite_status: 0 });
      setDataList(data);
    } catch (error) {
      console.error('Failed to fetch data:', error);
    }
  }, []);

  // Fetch all dropdown data
  const fetchDropdownData = useCallback(async () => {
    try {
      const [country, payment] = await Promise.all([
        getcountries(),
        getpaymentType(),
      ]);
      setDropdownData({
        countries: country,
        paymentType: payment,
      });
    } catch (error) {
      console.error('Error fetching dropdown data:', error);
    }
  }, []);

  useEffect(() => {
    const fetchDataAsync = async () => {
      setLoading(true);
      await fetchData();
      await fetchDropdownData();
      await new Promise((resolve) => setTimeout(resolve, 1000));
      setLoading(false);
    };
    fetchDataAsync();
  }, [fetchData, fetchDropdownData]);

  const handleSubmit = async () => {
    try {
      if (modalType === 'edit') {
        const updatedForm = { ...form, onsite_status: 1 };
        await updateData(updatedForm);
      }

      await fetchData();
      setShowModal(false);

      Swal.fire({
        icon: 'success',
        title: 'Approved!',
        text: 'Onsite participant approved successfully.',
        timer: 2000,
        showConfirmButton: false,
      });
    } catch (error) {
      console.error('Error updating status:', error);

      Swal.fire({
        icon: 'error',
        title: 'Error!',
        text: 'Something went wrong. Please try again.',
      });
    }
  };
   const parseNoteHistory = (note) => {
    try {
        let parsed = note;
        while (typeof parsed === 'string') parsed = JSON.parse(parsed);
        return Array.isArray(parsed) ? parsed : [];
    } catch { return []; }
    };

  const openModal = (type, data = {
    id: '',
    billing_address: '',
    billing_countries: '',
    billing_email: '',
    billing_full_name: '',
    billing_phone_no: '',
    createdAt: '',
    currency_type: '',
    no_of_ticket: '',
    occupancy_type: '',
    payment_id: '',
    payment_type: '',
    participant_type: '',
    pdf_status: '',
    refund_status: '',
    reg_amount: '',
    reg_amount_usd: '',
    reg_category: '',
    reg_type: '',
    series: '',
    note: '',
    notes: [],
    sub_domain: '',
    subject: '',
    updatedAt: '',
    }) => {
    setModalType(type);
    const history = parseNoteHistory(data.note);  // parse from data.note
    setForm({ ...data, notes: history });          // ← only ONE setForm call
    setShowModal(true);
    };

    const handleSearchChange = (e) => setSearchText(e.target.value);
    const handlePageChange = (page) => setCurrentPage(page);
   
  const getCurrencySymbol = (currencyCode) => {
    switch (currencyCode?.toUpperCase()) {
      case 'USD': return '$';
      case 'EUR': return '€';
      case 'INR': return '₹';
      case 'GBP': return '£';
      case 'RUB': return '₽';
      case 'THB': return '฿';
      default: return currencyCode || '';
    }
  };

  const getCountryName = (code) => {
    const country = dropdownData.countries.find((c) => c.code === code);
    return country ? country.name : code;
  };

  const getPaymentTypeName = (code) => {
    const payment = dropdownData.paymentType.find((c) => c.code === code);
    return payment ? payment.type : code;
  };

  const filteredData = useMemo(() => {
    return dataList
      .filter(
        (data) =>
          data.billing_full_name.toLowerCase().includes(searchText.toLowerCase()) ||
          data.sub_domain.toLowerCase().includes(searchText.toLowerCase())
      )
      .sort((a, b) => new Date(b.createdAt) - new Date(a.createdAt));
  }, [dataList, searchText]);

  const columns = [
    {
      name: '#',
      selector: (row, index) => (currentPage - 1) * 10 + (index + 1),
      sortable: false,
      width: '10%',
    },
    {
      name: 'Series',
      selector: (row) => {
        const date = new Date(row.series);
        const year = date.getFullYear();
        const month = date.getMonth();
        const months = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'];
        return `${months[month]} ${year}`;
      },
      sortable: true,
      wrap: true,
      width: '10%',
    },
    {
      name: 'Sub Domain',
      selector: (row) => row.sub_domain,
      sortable: true,
      wrap: true,
      width: '10%',
    },
    {
      name: 'Name',
      selector: (row) => row.billing_full_name,
      sortable: true,
      wrap: true,
      width: '15%',
    },
    {
      name: 'Country',
      selector: (row) => getCountryName(row.billing_countries),
      sortable: true,
      wrap: true,
      width: '15%',
    },
    {
      name: 'Reg Amount',
      selector: (row) => {
        const currencySymbol = getCurrencySymbol(row.currency_type);
        return <b className="fs-4">{currencySymbol} {row.reg_amount}</b>;
      },
      sortable: true,
      wrap: true,
      width: '10%',
    },
    {
      name: 'Actions',
      cell: (row) => (
        <div>
          <Button variant="danger" size="sm" onClick={() => openModal('edit', row)}>
            <i className="align-middle far fa-fw fa-file-pdf"></i> Edit
          </Button>
        </div>
      ),
    },
  ];

  return (
    <div className="d-flex">
      <Sidebar />
      <div className="main-content w-100">
        <Header />
        {loading ? (
          <div
            className="d-flex justify-content-center align-items-center w-100"
            style={{ minHeight: '300px' }}
          >
            <Spinner />
          </div>
        ) : (
          <div>
            <div className="container-fluid p-4">
              <div className="row">
                <div className="col-8">
                  <p className="fs-4 text-dark">
                    Conference Management / Participant Form / Pending Onsite Participant Form
                  </p>
                </div>
              </div>

              <DataTable
                columns={columns}
                data={filteredData}
                pagination
                highlightOnHover
                responsive
                striped
                paginationPerPage={10}
                paginationComponentOptions={{ noRowsPerPage: true }}
                onChangePage={handlePageChange}
                subHeader
                subHeaderComponent={
                  <div>
                    <input
                      className="form-control"
                      type="text"
                      placeholder="Search"
                      value={searchText}
                      onChange={handleSearchChange}
                    />
                  </div>
                }
              />

              {/* Modal for Edit */}
              <Modal className="modal-lg" backdrop="static" show={showModal} onHide={() => setShowModal(false)}>
                <Modal.Header closeButton>
                  <Modal.Title>{modalType === 'add' ? 'Add' : 'Edit'}</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                  <Table striped bordered hover responsive className="table-sm">
                    <thead>
                      <tr>
                        <th className="bg-secondary text-white" colSpan={2}>Payment Receipt Details</th>
                      </tr>
                    </thead>
                    <tbody>
                      <tr><td>Payment ID</td><td>{form.payment_id}</td></tr>
                      <tr><td>Participant Type</td><td>{form.participant_type}</td></tr>
                    </tbody>
                    <br />
                    <thead>
                      <tr>
                        <th className="bg-secondary text-white" colSpan={2}>Billing Address</th>
                      </tr>
                    </thead>
                    <tbody>
                      <tr><td>Full Name</td><td>{form.billing_full_name}</td></tr>
                      <tr><td>Email</td><td>{form.billing_email}</td></tr>
                      <tr><td>Phone No</td><td>{form.billing_phone_no}</td></tr>
                      <tr><td>Address</td><td>{form.billing_address}</td></tr>
                      <tr><td>Country</td><td>{getCountryName(form.billing_countries)}</td></tr>
                    </tbody>
                    <br />
                    <thead>
                      <tr>
                        <th className="bg-secondary text-white" colSpan={2}>Payment Description</th>
                      </tr>
                    </thead>
                    <tbody>
                      <tr><td>Mode of Payment</td><td>{getPaymentTypeName(form.payment_type)}</td></tr>
                      <tr><td>Currency</td><td>{form.currency_type}</td></tr>
                      <tr><td>Registration Amount</td><td>{form.reg_amount}</td></tr>
                      <tr><td>Registration Type</td><td>{form.reg_type}</td></tr>
                      <tr><td>Registration Category</td><td>{form.reg_category}</td></tr>
                      <tr><td>No. of Ticket</td><td>{form.no_of_ticket}</td></tr>
                      {form.occupancy_type && (
                        <tr><td>Occupancy</td><td>{form.occupancy_type}</td></tr>
                      )}
                      {form.total_no_of_nights && (
                        <tr><td>No. of Nights</td><td>{form.total_no_of_nights}</td></tr>
                      )}
                    </tbody>
                    
                  </Table>
                  {/* Notes History — display only */}
                    {form.notes?.length > 0 && (
                    <div className="mt-3">
                        <h6 className="fw-semibold text-dark mb-2">Notes History</h6>
                        <div
                        className="border rounded p-2"
                        style={{ maxHeight: '220px', overflowY: 'auto', backgroundColor: '#f8f9fa' }}
                        >
                        {form.notes.slice().reverse().map((n, i, arr) => (
                            <div key={i} style={{ display: 'flex', alignItems: 'flex-start', marginBottom: '10px' }}>
                            {/* Timeline dot & line */}
                            <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'center', width: '20px', marginRight: '10px', flexShrink: 0 }}>
                                <div style={{ width: '10px', height: '10px', borderRadius: '50%', background: '#6c757d', marginTop: '3px' }} />
                                {i !== arr.length - 1 && (
                                <div style={{ width: '2px', background: '#dee2e6', marginTop: '3px', minHeight: '28px' }} />
                                )}
                            </div>
                            {/* Note content */}
                            <div>
                                <div className="small mb-1">{n.value}</div>
                                {n.status && (
                                <span className={`badge me-1 text-white ${
                                    n.status === 'Approved' ? 'bg-success' :
                                    n.status === 'Closed'   ? 'bg-danger'  : 'bg-warning'
                                }`}>
                                    {n.status}
                                </span>
                                )}
                                <div className="text-muted" style={{ fontSize: '0.75rem' }}>{n.date}</div>
                            </div>
                            </div>
                        ))}
                        </div>
                    </div>
                    )}

                    {/* No notes message */}
                    {(!form.notes || form.notes.length === 0) && (
                    <p className="text-muted small mt-3 mb-0">No notes history available.</p>
                    )}
                </Modal.Body>
                <Modal.Footer>
                  <Button variant="secondary" onClick={() => setShowModal(false)}>Cancel</Button>
                  <Button variant="primary" onClick={handleSubmit}>Submit</Button>
                </Modal.Footer>
              </Modal>

            </div>
            <Footer />
          </div>
        )}
      </div>
    </div>
  );
};

export default PendingOnsiteParticipantForm;